import fileDownload from 'js-file-download';
import store from './../../../store';
import {openPDFViewer} from './../../../actions/shared/actions_shared_1';

export default function pdfHandler(data, fileName){
    const txt = 'Veuillez cliquer sur [OK] pour télécharger ou [ANNULER] pour visionner le document sur cette page.';
    if(window.confirm(txt)){
        fileDownload(data, fileName);
    }else{
        const file = new Blob([data], {type: 'application/pdf'});
        const fileURL = URL.createObjectURL(file);
        store.dispatch(openPDFViewer(fileURL));
    }
}


// WEBPACK FOOTER //
// ./src/components/shared/utils/pdfHandler.js